import React from 'react';

export const GlassChip = ({
  label,
  onDelete,
  variant = 'primary', // 'primary', 'success', 'warning', 'error'
  className = '',
}) => {
  return (
    <span className={`glass-chip ${variant !== 'primary' ? variant : ''} ${className}`}>
      <span className="label">{label}</span>
      {onDelete && (
        <span className="delete-icon" onClick={onDelete}>✕</span>
      )}
    </span>
  );
};